const HABITS_PATH = '/insights/habits'
const DEFAULT_POST_INSIGHTS_HREF = '/insights'
const FROM_PARAM = 'from'

export function isSafeInsightsHref(value: string): boolean {
  if (!value.startsWith('/insights') || value.startsWith('//')) {
    return false
  }

  if (value.includes('\\')) {
    return false
  }

  try {
    const url = new URL(value, 'https://publish.local')
    return (
      url.origin === 'https://publish.local' &&
      url.pathname.startsWith('/insights') &&
      url.pathname !== HABITS_PATH
    )
  } catch {
    return false
  }
}

export function getPostInsightsHref(search: string): string {
  const from = new URLSearchParams(search).get(FROM_PARAM)
  if (from && isSafeInsightsHref(from)) {
    return from
  }

  return DEFAULT_POST_INSIGHTS_HREF
}

export function buildHabitsHref(postInsightsHref: string): string {
  if (
    !isSafeInsightsHref(postInsightsHref) ||
    postInsightsHref === DEFAULT_POST_INSIGHTS_HREF
  ) {
    return HABITS_PATH
  }

  const params = new URLSearchParams()
  params.set(FROM_PARAM, postInsightsHref)
  return `${HABITS_PATH}?${params.toString()}`
}
